import { handleErrorDialog, showConfirmDialog } from '@juvare/common-web-ui/DialogHelper';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { showAlertSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { Typography } from '@mui/material';
import React from 'react';
export function showArchiveDialog({ t, functionClient, file, onSuccess }) {
    const fileEntityType = file.columns.directory ? t('common.folder') : t('common.file');
    showConfirmDialog({
        title: t('archiveDialog.title', { fileName: file.columns.name }),
        content: (React.createElement(Typography, { variant: 'body1', color: themeColors.text.subtle, "data-test": 'confirm-archive-message' }, t('archiveDialog.description'))),
        confirmLabel: t('archiveDialog.submitButtonLabel'),
        onConfirm: () => {
            functionClient
                .executeFunction({ functionName: 'archiveFile', params: { fileId: file.id } })
                .then(() => {
                showAlertSnackbar({
                    horizontalPosition: 'center',
                    type: 'success',
                    verticalPosition: 'bottom',
                    autoHideDuration: 2000,
                    message: t('archiveDialog.archivedSnackbar', { fileEntityType }),
                });
                onSuccess();
            })
                .catch(handleErrorDialog);
        },
    });
}
